module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 4H14V2c0-1.1-.9-2-2-2H2C.9 0 0 .9 0 2v28c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 15a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3h-3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/add-folder-1.js
// module id = 976
// module chunks = 14